export enum FEATURES {
    Obd = "obd"
}

export enum FEATURE_NAMES {
    Obd = "obd oem"
}
